export default {
  path: '/tools',
  name: 'tools',
  component: () => import('../components/tool/Layout'),
  redirect: { name: 'ToolList' },
  meta: {
    breadcrumb: 'profile.tool.tools',
  },
  children: [
    {
      name: 'ToolList',
      path: '',
      component: () => import('../views/tool/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ToolCreate',
      path: 'new',
      component: () => import('../views/tool/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ToolUpdate',
      path: ':id/edit',
      component: () => import('../views/tool/Update'),
      meta: {
        breadcrumb: 'profile.tool.tool',
      },
    },
    {
      name: 'ToolShow',
      path: ':id',
      component: () => import('../views/tool/Show'),
      meta: {
        breadcrumb: 'profile.tool.tool',
      },
    }
  ]
};
